module.exports = __webpack_public_path__ + "img/bg.087ae03f.png";